import {
  ContentContainer,
  ContentHeader,
  PageTitle,
} from "features/layout/components";

import useIntegrationSettings from "common/datahooks/useIntegrationSettings";
import { typedObjectEntries } from "common/helpers/utils";

import { INTEGRATIONS_MAP } from "../constants";
import ConnectedIntegrationSettings from "./ConnectedIntegrationSettings";
import ConnectOutreachIntegration from "./ConnectOutreachIntegration";
import IntegrationItem from "./IntegrationItem";

import type { JSX } from "react";

export default function IntegrationsList() {
  const { integrationSettings } = useIntegrationSettings();

  return (
    <ContentContainer>
      <ContentHeader>
        <PageTitle />
      </ContentHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 p-4">
        {typedObjectEntries(INTEGRATIONS_MAP).map(
          ([key, { icon, title, description, ...rest }]) => {
            const commonIntegrationItemProps = {
              icon,
              type: key,
              description,
            };
            let integrationItemProps:
              | { redirectUrl: string }
              | { settingsComponent: JSX.Element; hasError?: boolean };

            if ("redirectUrl" in rest) {
              integrationItemProps = { redirectUrl: rest.redirectUrl };
            } else {
              if (!integrationSettings) {
                return (
                  <IntegrationItem
                    key={key}
                    {...commonIntegrationItemProps}
                    isLoading
                  />
                );
              }

              if (
                key === "hubspot" ||
                key === "pipedrive" ||
                key === "rb2b" ||
                key === "instantly" ||
                key === "smartlead" ||
                key === "emailbison"
              ) {
                const settings = integrationSettings[key];

                const isDisconnectedOutreach =
                  !settings &&
                  (key === "instantly" ||
                    key === "smartlead" ||
                    key === "emailbison");

                if (settings && "install_url" in settings) {
                  integrationItemProps = { redirectUrl: settings.install_url };
                } else {
                  integrationItemProps = {
                    settingsComponent: isDisconnectedOutreach ? (
                      <ConnectOutreachIntegration type={key} />
                    ) : (
                      <ConnectedIntegrationSettings
                        integrationKey={key}
                        settings={settings}
                      />
                    ),
                    hasError: !!settings && "error" in settings,
                  };
                }
              }
            }

            return (
              <IntegrationItem
                key={key}
                {...commonIntegrationItemProps}
                {...integrationItemProps}
              />
            );
          },
        )}
      </div>
    </ContentContainer>
  );
}
